<template>
  <div class="cart-container">
    <div class="cart-content">
      <table class="cart-table">
        <tr>
          <th class="text-left">{{ $t('cart_table.table_header.packages') }}</th>
          <th class="pc-only-column">{{ $t('cart_table.table_header.net_monthly_fee') }}</th>
          <th class="pc-only-column">{{ $t('cart_table.table_header.net_device_price') }}</th>
          <th class="pc-only-column">{{ $t('cart_table.table_header.net_install_fee') }}</th>
          <th>{{ $t('cart_table.table_header.piece') }}</th>
          <th class="payment-sum">{{ $t('cart_table.table_header.net_sum_price') }}</th>
        </tr>
        <tr class="cart-element" v-for="product in getDisplayedProducts()" :key="product.id">
          <td class="text-left"> {{ product.label }}</td>
          <td class="pc-only-column">{{ $price(product.monthlyPricing) }}</td>
          <td class="pc-only-column">{{ product.deviceCost === 0 ? $t('common.free') : $price(product.deviceCost) }}</td>
          <td class="pc-only-column">{{ product.installationCost === 0 ? $t('common.free') : $price(product.installationCost) }} </td>
          <td>
            <sc-counter class="quantity-counter"
                    :defaultValue="product.quantity"
                    :max="99"
                    :min="0"
                    @increase="counterIncrease($event, product)"
                    @decrease="counterDecrease($event, product)" />
          </td>
          <td>{{ $price(product.sum) }}</td>
        </tr>
        <tr class="spacer">
          <td></td>
          <td class="pc-only-column"></td>
          <td class="pc-only-column"></td>
          <td class="pc-only-column"></td>
          <td></td>
          <td></td>
        </tr>
        <tr class="discount" v-for="discount in discounts" :key="discount.code">
          <td class="pc-only-column"></td>
          <td class="pc-only-column"></td>
          <td class="pc-only-column"></td>
          <td class="discount-label" colspan="2">{{ $t('discounts.' + discount.code) }}</td>
          <td class="payment-sum">{{ $price(getDiscountAmount(discount)) }}</td>
        </tr>
        <tr>
          <td class="pc-only-column"></td>
          <td class="pc-only-column"></td>
          <td class="pc-only-column"></td>
          <td class="discount-label" colspan="2">{{ $t('cart_table.net_sum') }}</td>
          <td class="payment-sum">{{ $price(getTotalNetCost()) }}</td>
        </tr>
        <tr>
          <td class="pc-only-column"></td>
          <td class="pc-only-column"></td>
          <td class="pc-only-column"></td>
          <td class="discount-label" colspan="2">{{ $t('cart_table.vat_cost') }}</td>
          <td class="payment-sum">{{ $price(getTotalVatCost()) }}</td>
        </tr>
        <tr class="sum total-cost">
          <td class="pc-only-column"></td>
          <td class="total-cost-label pc-only-column" colspan="4">{{ $t('cart_table.gross_sum_paid_now', { loyaltyTime: getSelectedLoyalty }) }}</td>
          <td class="total-cost-label mobile-only-column" colspan="2">{{ $t('cart_table.gross_sum_paid_now', { loyaltyTime: getSelectedLoyalty }) }}</td>
          <td class="payment-sum">{{ $price(getTotalGrossCost()) }}</td>
        </tr>
        <tr class="spacer monthly" v-if="hasMonthlyPayment">
          <td></td>
          <td class="pc-only-column"></td>
          <td class="pc-only-column"></td>
          <td class="pc-only-column"></td>
          <td></td>
          <td></td>
        </tr>
        <tr class="sum monthly-net-total" v-if="hasMonthlyPayment">
          <td class="pc-only-column"></td>
          <td class="pc-only-column"></td>
          <td class="pc-only-column"></td>
          <td class="monthly-cost-label" colspan="2">{{ $t('cart_table.net_monthly_fee_from_next_month') }}</td>
          <td class="monthly-fee">{{ $price(getMonthlyNetTotal()) }}</td>
        </tr>
        <tr class="sum monthly-vat-cost" v-if="hasMonthlyPayment">
          <td class="pc-only-column"></td>
          <td class="pc-only-column"></td>
          <td class="pc-only-column"></td>
          <td class="monthly-cost-label" colspan="2">{{ $t('cart_table.net_monthly_fee_vat_cost') }}</td>
          <td class="monthly-fee">{{ $price(getMonthlyVatCost()) }}</td>
        </tr>
        <tr class="sum monthly-gross-total" v-if="hasMonthlyPayment">
          <td class="pc-only-column"></td>
          <td class="pc-only-column"></td>
          <td class="pc-only-column"></td>
          <td class="monthly-cost-label" colspan="2">{{ $t('cart_table.gross_monthly_fee_from_next_month') }}</td>
          <td class="monthly-fee">{{ $price(getMonthlyGrossTotal()) }}</td>
        </tr>
      </table>
    </div>
    <div class="stars-comment">
      {{ $t('cart_table.stars_comment') }}
    </div>
  </div>
</template>

<script>
import { PackageNameLabels, VehicleGroupLabels } from '@/shared/utils/Labels'
import { ScCounter } from 'smartcommerce-component-library'
import { OrderWizardActionTypes as actions } from '../../order-wizard/store/action-types'

export default {
  name: 'CartSummary',

  components: { ScCounter },

  computed: {
    discounts () {
      return this.$store.getters.getDiscountsInCart()
    },
    hasMonthlyPayment () {
      return this.$store.state.billingCycleMonths === 1
    },
    getSelectedLoyalty () {
      let loyalty = this.$store.state.selectedLoyalty
      return loyalty === 0 ? this.$t('package_selector.no_loyalty').toLowerCase() : this.$t('package_selector.loyalty', { value: loyalty }).toLowerCase()
    }
  },
  methods: {
    getDiscountAmount (discount) {
      return -1 * this.$store.getters.getCartNetMonthlyFeesWithoutDiscount() * discount.discountPercent
    },

    getDisplayedProducts () {
      let options = []
      let categoriesInCart = this.$store.getters.getProductsInCartMappedByGroupAndPackage()

      for (let groupCode in categoriesInCart) {
        if (!categoriesInCart.hasOwnProperty(groupCode)) continue

        for (let packageCode in categoriesInCart[groupCode]) {
          if (!categoriesInCart[groupCode].hasOwnProperty(packageCode)) continue
          if (categoriesInCart[groupCode][packageCode].length === 0) continue
          let currentElement = categoriesInCart[groupCode][packageCode][0]
          let productPackage = currentElement.product
          let quantity = currentElement.quantity
          let sum = quantity * currentElement.product.getTotalNetPrice(this.$store.state.billingCycleMonths)

          options.push({
            label: this.$t('vehicle_registration.vehicle_type_and_package', {
              vehicleType: this.$t(VehicleGroupLabels[groupCode]),
              package: this.$t(PackageNameLabels[packageCode])
            }),
            quantity,
            monthlyPricing: productPackage.monthlyFee,
            grossMonthlyPricing: productPackage.grossMonthlyFee,
            deviceCost: productPackage.getNetDevicePrice(),
            installationCost: productPackage.getNetInstallFee(),
            sum,
            $product: productPackage
          })
        }
      }
      return options
    },

    getTotalGrossCost () {
      return this.$store.getters.getTotalGrossCost()
    },

    getTotalNetCost () {
      return this.$store.getters.getTotalNetCost()
    },

    getMonthlyNetTotal () {
      return this.getDisplayedProducts().reduce((acc, val) => acc + val.monthlyPricing * val.quantity, 0)
    },

    getMonthlyGrossTotal () {
      return this.getDisplayedProducts().reduce((acc, val) => acc + val.grossMonthlyPricing * val.quantity, 0)
    },

    getMonthlyVatCost () {
      return this.getDisplayedProducts().reduce((acc, val) => acc + val.grossMonthlyPricing * val.quantity - val.monthlyPricing * val.quantity, 0)
    },

    getTotalVatCost () {
      return this.$store.getters.getTotalVatCost()
    },

    counterIncrease (number, productPackage) {
      this.$store.dispatch(actions.ADD_TO_CART, { productPackage: productPackage.$product, quantity: 1 })
    },

    counterDecrease (number, productPackage) {
      this.$store.dispatch(actions.REMOVE_FROM_CART, { productPackage: productPackage.$product, quantity: 1 })
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../styles/variables';

.cart-container {
  .cart-content {
    margin: 0 auto;

    .cart-table {
      width: 100%;
      line-height: 30px;

      th {
        border-bottom: 2px rgb(219, 217, 217) solid;
      }

      tr {
        &.sum {
          &.total-cost {
            line-height: 50px;
          }
        }

        &.total-cost {
          font-weight: 800;
        }

        td:nth-child(6) {
          width: 200px;
        }
      }

      .quantity-counter {
        align-items: center;

        /deep/ .sc-counter-button {
          font-size: 12px;
          width: 18px;
          height: 18px;
          border-radius: 2px;

          span {
            font-size: 12px;
          }
        }

        /deep/ .sc-counter-value {
          font-size: 16px;
          width: auto;
          height: auto;
          color: #ffffff;
          margin: 0 10px;
        }
      }
    }
  }

  .stars-comment {
    font-size: 12px;
    line-height: 20px;
  }
}

.mobile-only-column{
  display: none;
}

@media(max-width: 768px) {
  .pc-only-column{
    display: none;
  }

  .mobile-only-column{
    display: table-cell;
  }

  .cart-container .cart-content .cart-table tr td:nth-child(6) {
    width: 100px;
  }

  .total-cost-label{
    line-height: 25px;
    padding: 15px 0px;
  }

  .monthly-cost-label{
    line-height: 22px;
    padding: 10px 20px;
  }

  .cart-container .cart-content .cart-table {
    width: 100% !important;
  }
}
</style>
